export class EventEmitter {
    private events: Array<{ name: string; cb: (...params: any[]) => void }> =
        [];
    public static EVENT = {
        ON_CONTENT_SCROLL: "onContentScroll",
        ON_CONTENT_READY: "onContentReady",
        ON_CHANGE_STEP: "onChangeStep",
    };

    on<Event = any>(eventName: string, cb: (e: Event) => void): void {
        this.events.push({ name: eventName, cb });
    }

    emit<Event = any>(eventName: string, data?: Event): void {
        for (const event of this.events) {
            if (event.name === eventName) {
                event.cb(data);
            }
        }
    }

    off(eventName: string, cb: (...params: any[]) => void): void {
        const index = this.events.findIndex(
            (event) => event.name === eventName && event.cb === cb,
        );
        if (index !== -1) {
            this.events.splice(index, 1);
        }
    }
}
